import React, { useEffect, useState } from "react";
import { formatDate } from "../../../functions/dateTime/formatDate";
import { Calendar } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import useClickOutside from "../../../CustomHooks/useClickOutside";
import { formatDateString } from "../../../functions/dateTime/formatDateString";

const DateInput = ({
  label,
  name,
  value = "",
  setValue,
  register,
  error,
  render,
  disableCurrentAndFutureDays,
  disableFutureDays,
  disablePastDates,
}) => {
  const [date, setDate] = useState(value);
  const [showDatePicker, serShowDatePicker] = useState(-1);
  const { dropdownRef } = useClickOutside(() => serShowDatePicker(-1));

  const handleShowDatePicker = () => {
    serShowDatePicker((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  useEffect(() => {
    if (date) {
      setValue(name, formatDateString(date), { shouldValidate: true });
    } else {
      setValue(name, "");
    }
  }, [date, name, setValue]);

  useEffect(() => {
    setDate(value);
  }, [value, render]);

  const today = new Date();
  const currentYear = today.getFullYear();
  const disabledDays = (() => {
    const today = new Date();
    if (disableCurrentAndFutureDays) {
      return {
        after: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1, // Disable current day and all future days
        ),
      };
    } else if (disableFutureDays) {
      return {
        after: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Disable future days but not today
      };
    } else if (disablePastDates) {
      return {
        before: today,
      };
    }
    return false; // No days are disabled if neither condition is true
  })();
  return (
    <div>
      <label
        htmlFor="date-time-input"
        className="font-poppins text-dg2 text-xs lg:text-sm"
      >
        {label}
      </label>
      <div className="relative" ref={dropdownRef}>
        <div onClick={handleShowDatePicker} className="cursor-pointer">
          <label
            htmlFor="custom-calendar"
             className="text-xs lg:text-sm font-poppins absolute left-1 pl-2 pr-3 top-[10px] lg:top-3 bg-white"
          >
            {date ? formatDate(date) : "Select Date"}
          </label>
          <Calendar
            color="gray"
            className="absolute right-1 lg:right-2 top-1 lg:top-3 w-4 lg:w-5"
          />
          <input
            name={name}
            type="text"
            readOnly="readonly"
            value={value}
            className={`w-full border-bw text-xs lg:text-sm rounded-md cursor-pointer py-2 lg:py-3 px-2 lg:px-3 focus-input ${
              error ? "border-red-500" : "border-lg4"
            }`}
            {...register}
          />
        </div>
        {showDatePicker === 1 && (
          <div className="shadow-sh-1 rounded-md border max-w-xs absolute left-0 top-12 bg-white z-9999">
            <DayPicker
              mode="single"
              captionLayout="dropdown"
              fromYear={1900}
              toYear={currentYear}
              selected={date}
              onSelect={setDate}
              disabled={disabledDays}
              classNames={{
                caption_label:
                  "font-bold flex items-center mr-3 mb-2 text-xs lg:text-sm",
                head_row: "flex font-medium text-gray-900 ",
                head_cell: "w-6 lg:w-7 font-normal text-xs lg:text-sm",
                row: "flex w-full",
                cell: "text-gray-600 rounded-md h-6 lg:h-7 w-6 lg:w-7 text-center text-xs lg:text-sm p-0",
                day: "h-6 lg:h-7 w-6 lg:w-7 p-0 font-normal",
                day_range_end: "day-range-end",
                day_selected: "rounded-md focus:bg-gray-900 focus:text-white",
              }}
            />
          </div>
        )}
        <p
          className={`text-red-500 font-figtree text-[10px] lg:text-xs h-3 lg:h-4 ${
            error ? "visible" : "invisible"
          }`}
        >
          {error?.message}
        </p>
      </div>
    </div>
  );
};

export default DateInput;
